<alert [type]="type">
    <div [innerHtml]="message | safeHtml" routeLink></div>
    <div *ngFor="let item of messages| keyvalue">
        {{item.key}}: {{item.value}}
    </div>
    <ng-content></ng-content>
</alert>
